import { AlarmLogUiState } from '@/store/modules/alarmLogUi/types'

export const state: AlarmLogUiState = {
  interacted: false,
}
